import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App.js';

// Register the service worker that makes the dashboard installable. autoUpdate
// means a new deploy is picked up on the next load without a prompt.
registerSW({ immediate: true });

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
